import { render, staticRenderFns } from "./Ganancias.vue?vue&type=template&id=a44d4f64&scoped=true&"
import script from "./Ganancias.vue?vue&type=script&lang=js&"
export * from "./Ganancias.vue?vue&type=script&lang=js&"
import style0 from "./Ganancias.vue?vue&type=style&index=0&id=a44d4f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44d4f64",
  null
  
)

export default component.exports